import { render, staticRenderFns } from "./ReSendDialog.vue?vue&type=template&id=4b076318&scoped=true"
import script from "./ReSendDialog.vue?vue&type=script&lang=js"
export * from "./ReSendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b076318",
  null
  
)

export default component.exports